import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

/**
 * The composting register's detail view lives in ONE canonical place rather
 * than under each parent tab.
 *
 * A register entry's link to properties is many-to-many — a shared composter
 * (*kimppa*) covers several addresses — so a property-scoped URL would not be
 * well defined for exactly the entries that need it most. It is also reachable
 * from an Individual, so a single owner-scoped path would be a lie half the
 * time.
 *
 * PRO-26 is the other half of the reason: `TabsNavigationExtended` matches its
 * route non-exactly, so a detail path nested under a tab would render INSIDE
 * the tab strip — the re-nesting anti-pattern the ruling forbids.
 *
 * The tabs link here and pass `?from=` so the back affordance can name the
 * list the reader came from.
 */
export const createCompostingRegistriesRouteMap = (prefix: string) => ({
  '/:id': (id: string) =>
    pathJoin(prefix)(id).chainWithTitle({
      title: <T _str="Composting notification" />,
      breadCrumbTitle: <T _str="Details" />,
    }),
})
